import { useState, type ReactNode } from "react";

/**
 * A small ⓘ icon that pops up a help tooltip when clicked. Used to
 * annotate dashboards / charts so the operator can read "what is this?"
 * without burying explanations in the page copy.
 */
export function HelpIcon({ title, children }: { title?: string; children: ReactNode }) {
  const [open, setOpen] = useState(false);
  return (
    <span style={{ position: "relative", display: "inline-block", marginLeft: 6 }}>
      <button
        type="button"
        aria-label={title ?? "What is this?"}
        onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}
        onBlur={() => setOpen(false)}
        className="ghost"
        style={{
          width: 20, height: 20, padding: 0, borderRadius: "50%",
          fontSize: 11, lineHeight: 1, cursor: "pointer",
          background: "var(--accent-soft)", color: "var(--accent)", border: "none",
        }}
      >?</button>
      {open && (
        <div
          role="tooltip"
          onClick={(e) => e.stopPropagation()}
          style={{
            position: "absolute",
            top: 28,
            left: -120,
            width: 280,
            zIndex: 80,
            background: "var(--panel)",
            border: "1px solid var(--border)",
            borderRadius: 8,
            padding: "10px 12px",
            fontSize: 12,
            lineHeight: 1.5,
            color: "var(--text)",
            boxShadow: "0 6px 20px rgba(15,23,42,0.12)",
            whiteSpace: "normal",
          }}
        >
          {title && <div style={{ fontWeight: 600, marginBottom: 4 }}>{title}</div>}
          {children}
        </div>
      )}
    </span>
  );
}
